/**
 * @file: ListModelAbstract.js
 * @author: liuye11(liuye11@baidu.com)
 */

import subDays from 'date-fns/sub_days';
import uri from '@baidu/ve-ria/utils/uri';
import {assign, isNaN, pick} from 'lodash';
import {fillMissingDay} from '@/common/utils';
import ListModel from '@baidu/ve-ria/views/ListModel';

export default class Model extends ListModel {

    /**
     * @override
     */
    title = '';
    pageSizes = [20, 50, 100];
    beginKey = 'startDate';
    endKey = 'endDate';
    timeFormat = 'YYYYMMDD';

    filter = assign(this.filter, {
        aderId: 0,
        timeRange: [subDays(new Date(), 7), subDays(new Date(), 1)],
        pageSize: 20
    });

    // 广告主数据源
    aderDatasource = [];

    // 趋势曲线数据
    trendData = [];

    trendRequester = null;

    init() {
        super.init();
        this.cardStatusMap = this.getConstantMap('CARD_STATUS');
        this.isAdmin = !!this.getRouteMeta().isAdmin;

        if (this.isAdmin) {
            this.aderListRequester = this.api.aderList;
            this.requestAderList();
        }
    }

    /**
     *  获取广告主列表
     */
    async requestAderList() {
        try {
            let data = await this.aderListRequester();
            if (data && data.length) {
                this.aderDatasource = [
                    {label: '全部', value: 0},
                    ...data.map(item => {
                        return {
                            label: item.name,
                            value: item.id
                        };
                    })
                ];
            }
        }
        catch (e) {
            throw e;
        }
    }

    /**
     * 获取趋势曲线数据
     *
     * @param {Object} params 物料ID: {id} or {componentInstanceId}
     */
    async requestTrendData(params) {
        try {
            let dateParams = this.pickParamsWithDate();
            let result = await this.trendRequester(assign(params, dateParams));
            this.trendData = this.fillMissingDayData(result, dateParams);
        }
        catch (e) {
            this.trendData = [];
            throw e;
        }
    }

    toPercentText(val) {
        if (isNaN(val) || val < 0) {
            return '-';
        }
        return val.toFixed(2) * 100 + '%';
    }

    // 获取下载报告URL
    getDownloadUrl() {
        return uri.withQuery(this.downloadApi, this.pickParamsWithDate('aderId'));
    }

    /**
     * 获取请求参数，默认携带日期参数 beginKey, endKey
     *
     * @param {...string} args 参数名，多个或空
     * @return {Object}
     */
    pickParamsWithDate(...args) {
        return pick(this.prepareQuery(), [...args, this.beginKey, this.endKey]);
    }

    fillMissingDayData(data, {startDate, endDate}) {
        // 填充基础指标图表默认值
        return fillMissingDay(data, startDate, endDate, {
            pv: 0,
            click: 0,
            clickRatio: 0
        });
    }
}
